import {useQuery, gql} from "@apollo/client";
import {useContext, useEffect, useMemo} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";
import {ResortsContext} from "../store/providers/ResortsProvider";

const QUERY = gql`
    query getResortDetail($hapimagResortId: Int!, $locale: String!) {
        resortCollection(limit: 1, where: { hapimagResortId: $hapimagResortId }, locale: $locale) {
            items {
                hapimagResortId
                isOnlineBookable
                resortName
                slug
                houseboat
                destination {
                    destination
                    slug
                    country{
                        country
                        slug
                    }
                }
                payment {
                    paymentTitle
                    paymentInformation
                    paymentInformationWithPointsPurchase
                }
                sys {
                    id
                }
            }
        }
    }
`;

export const useResortDetail = (hapimagResortId) => {
    const {localeUppercase, localeUppercaseUnderscore} = useContext(LocaleContext)[0];
    const [resortsStateAndIds, resortsDispatch] = useContext(ResortsContext);
    const {resorts, resortsLoading} = resortsStateAndIds;
    const {logger} = useLogger();
    const { loading, error, data } = useQuery(QUERY, {
        variables: { hapimagResortId, locale: localeUppercase },
        errorPolicy: "all"
    });

    useEffect(() => {
        if (resorts && !resorts.length && !resortsLoading) {
            resortsDispatch({type: "GET_RESORTS_INIT", payload: {locale: localeUppercaseUnderscore, is_bookable: true}});
        }
    }, [resorts]);

    const resortDetails = data?.resortCollection?.items[0];
    const resortTags = resortDetails?.resortPositioningCollection?.items?.map(({ title }) => title);

    if (error?.message) {
        logger(error?.message, "error", "useResortDetail", error?.stack);
    }

    return useMemo(() => ({
        resortDetails: resortDetails ? {
            ...resortDetails,
            isPartner: resorts.find(r => r.hapimagResortId === resortDetails?.hapimagResortId)?.isPartner
        } : undefined,
        resortTags,
        loading: loading || resortsLoading,
        error
    }), [
        resortDetails,
        resorts,
        resortTags,
        loading,
        error,
        resortsLoading
    ]);
};
